<template>
  <div class="account-right-item upload">
    <template v-if="isWhiteUser">
    <h4>我上传的作品</h4>
    <div class="uploadContent">
      <div class="upload-header">
        <div class="upload-header-left">
          <ul class="upload-list">
            <li :class="['upload-list-item', {'active': item.type === curType}]" v-for="(item,index) in status_type" @click="tabChange(item)">{{item.title}}</li>
          </ul>

        </div>
        <div class="upload-header-right">
          <p class="f1">
            <span class="curPageColor">{{page.curPage}}</span>
            <span>/</span>
            <span>{{page.totalPage}}</span>
          </p>
          <div class="f2">
            <a class="arrow-left" href="javascript:;" @click="doSelect(page.curPage-1)" :class="{'page-active':page.curPage<=1}">
              <img src="../../../images/personal_center/collection-left.png" alt="">
            </a>
            <a class="arrow-right" href="javascript:;" @click="doSelect(page.curPage+1)" :class="{'page-active':page.curPage>=page.totalPage}">
              <img src="../../../images/personal_center/collection-right.png" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="upload-body">

        <ul class="content">
          <router-link to="/s-mart/personal_center/user_upload" v-show="isShow && !isProductLoading">
            <li class="upload-add" v-if="curType === 'all'">
              <i class="bk-icon icon-plus-circle"></i>
            </li>
          </router-link>
          <li class="images-list" v-for="item in lists">
            <router-link :to="{path:'/s-mart/personal_center/works/'+item.app_id+'/detail'}">
              <div class="upload-images">
                <img :src="item.app_logo" alt="">
              </div>
              <!-- <p >审核中</p> -->
              <div v-if="item.online_status === 'is_publish'" class="publish">
                <span class="tips">{{item.app_name}}</span>
              </div>
              <div v-if="item.online_status === 'is_down'" class="downMask">
                <p v-if="item.online_status === 'is_down'" class="down">
                  已下架
                </p>
                <span class="tips">{{item.app_name}}</span>
              </div>
            </router-link>
            <div v-if="item.online_status === 'is_auditing'" class="checkMask">
              <p v-if="item.online_status === 'is_auditing'" class="check">
                审核中
              </p>
              <span class="tips">{{item.app_name}}</span>
            </div>
          </li>
        </ul>

        <div class="upload-search-null" v-show="isNullCheck&&!isProductLoading">
          <img src="../../../images/personal_center/work-null.png" alt="" />
          <p>未搜索到相关的内容，
            <router-link to="/s-mart/personal_center/user_upload">
              开始上传
            </router-link>
          </p>
        </div>
      </div>
      <!-- 加载的子组件 -->
      <loading :ifLoadingStart="isProductLoading" style="padding: 30px 0"></loading>
      <!-- 弹出框子组件 -->
      <v-alert :options="options"></v-alert>
    </div>
    </template>
    <template v-else>
      <div class="upload-search-null">
        <img src="../../../images/personal_center/work-null.png" alt="" />
        <p>您不是白名单用户，请联系客服！
        </p>
      </div>
    </template>
  </div>
</template>

<script type="text/javascript">
  import vAlert from '../../alert.vue' //导入弹出框子组件
  import loading from '../../loading.vue' //导入加载子组件
  export default {
    props: {
      uploadNum: {
        default: 0,
        type: Number
      }
    },
    data() {
      return {
        tips: '', //tooltips提示框
        isNullData: false, //默认加载页面时数据为空
        isShow: false, //上传文件加号框
        isNullCheck: false, //审核状态为空
        isProductLoading: true, // 默认显示加载组件
        options: {},
        type: '',
        isWhiteUser: true,
        status_type: [{
          title: "全部",
          type: 'all'
        }, {
          title: "已发布",
          type: 'publish'
        }, {
          title: "审核中",
          type: 'check'
        }, {
          title: "已下架",
          type: 'down'
        }],
        // statusIndex: '',
        curType: 'all',
        lists: [],
        page: {
          curPage: 1, //当前页数
          per_page: 10, //每页多少条数据
          totalPage: 1 //总页数
        }
      }
    },
    methods: {
      initWhiteUser () {
        axios.get(myUrl + `packman/ee/list/`).then((res) => {
          if (res.data.result && res.data.data.length) {
            this.isWhiteUser = true
          } else {
            this.isWhiteUser = false
          }
        })
      },
      tabChange(item) {
        this.curType = item.type;
      },
      doSelect(page) {
        if (page < 1 || page > this.page.totalPage) {
          return;
        } else {
          // 初始化,清除缓存
          this.isProductLoading = true;
          this.isNullCheck = false;
          this.lists = [];

          // 请求参数
          let params = {};
          params['page'] = page;
          params['per_page'] = this.page.per_page;

          switch (this.curType) {
            case 'all':
              break;
            case 'publish':
              params['is_publish'] = 1;
              break;
            case 'check':
              params['is_auditing'] = 1;
              break;
            case 'down':
              params['is_down'] = 1;
              break;
          }

          axios.post(myUrl + "core/i/product/filter/", qs.stringify(params)).then((res) => {
            if (res.data.data) {
              // console.log(res.data.data);
              this.isProductLoading = false;
              if (res.data.data.items.length === 0) {
                this.lists = [];
                this.isShow = false;
                this.isNullCheck = true;
                this.isNullData = true;
              } else {
                this.isShow = true;
                let resData = res.data.data;
                this.page.curPage = resData.page.curPage;
                this.page.totalPage = resData.page.totalPage;
                this.lists = resData.items;
                this.$emit('update:uploadNum', this.lists.length)
                this.isNullCheck = false;

              }
            } else {
              // 错误提示
              this.options = {
                msgIsSuccess: false,
                msgText: res.message
              }
            }
          })
        }
      }
    },
    watch: {
      // tab切换时curType发生变化
      curType() {
        this.doSelect(1);
      },
    },
    mounted() {
      //页面加载时，先调用一次方法，显示默认列表
      this.doSelect(1);
      this.initWhiteUser();
    },
    components: {
      "v-alert": vAlert,
      loading
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .upload {
    min-height: 640px;
    padding: 15px 45px 65px;
    position: relative;
    h4 {
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
      color: #77787f;
      border-bottom: 1px solid #f4f4f4;
      margin-bottom: 20px;
    }
    .uploadContent {
      .upload-header {
        position: relative;
        width: 100%;
        height: 26px;
        margin-bottom: 25px;
        .upload-header-left {
          box-sizing: border-box;
          float: left;
          .upload-list {
            box-sizing: border-box;
            height: 26px;
            width: 212px;
            cursor: pointer;
            overflow: hidden;
            vertical-align: middle;
            border-bottom-right-radius: 2px;
            border-top-right-radius: 2px;
            .upload-list-item {
              box-sizing: border-box;
              color: #a6a6a6;
              font-size: 12px;
              float: left;
              width: 53px;
              height: 26px;
              line-height: 24px;
              text-align: center;
              border-left: 1px solid #ddd;
              border-top: 1px solid #ddd;
              border-bottom: 1px solid #ddd;
              &:first-of-type {
                border-left: 1px solid #ddd;
                border-bottom-left-radius: 2px;
                border-top-left-radius: 2px;
              }
              &:last-of-type {
                border-right: 1px solid #ddd;

              }
              &.active {
                background-color: #20a0ff;
                color: white;
                border: 1px solid #20a0ff;
              }
            }
          }
        }

        .upload-header-right {
          position: absolute;
          right: 0px;
          top: 0px;
          box-sizing: border-box;
          .f1 {
            float: left;
            font-size: 12px;
            line-height: 26px;
            .curPageColor {
              color: #ff6600;
            }
          }
          .f2 {
            float: right;
            margin-left: 20px;
            border: 1px solid #dddddd;
            border-radius: 3px 0 0 3px;
            box-sizing: border-box;
            background-color: #fff;
            .arrow-left {
              display: block;
              float: left;
              box-sizing: border-box;
              width: 53px;
              height: 24px;
              border-right: 1px solid #ddd;
              text-align: center;
            }
            .arrow-left.page-active {
              background-color: #f1f1f1;
            }
            .arrow-right {
              float: right;
              display: block;
              box-sizing: border-box;
              width: 53px;
              height: 24px;
              text-align: center;
            }
            .arrow-right.page-active {
              background-color: #f1f1f1;
            }
          }
        }
      }
      .upload-body {

        .content {
          box-sizing: border-box;
          /* width: 821px; */
          float: left;
          /* height: 522px; */
          margin-left: -8px;
          margin-right: -8px;
          .upload-add {
            box-sizing: border-box;
            width: 88px;
            height: 88px;
            border: 1px dashed #e6e6e7;
            background-color: #fafafa;
            text-align: center;
            line-height: 96px;
            margin-right: 8px;
            margin-left: 8px;
            float: left;
            >i {
              display: inline-block;
              font-size: 24px;
              color: #a6a6a6;
            }
          }
          .images-list {
            position: relative;
            float: left;
            margin-right: 8px;
            margin-left: 8px;
            margin-bottom: 8px;
            .upload-images {
              background-color: #fafafa;
              width: 88px;
              height: 88px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .publish {
              position: absolute;
              top: 0px;
              left: 0px;
              width: 88px;
              height: 88px;
              background-color: transparent;
              &:hover {
                .tips {
                  font-family: 'pingFang-SC-Regular', '微软雅黑', Arial;
                  display: inline-block;
                }
              }
              p {
                position: absolute;
                left: 15px;
                top: 32px;
                width: 58px;
                height: 24px;
                background-color: #20a0ff;
                color: white;
                line-height: 24px;
                text-align: center;
                border-radius: 5px;
                &.down {
                  background-color: #fafafa;
                  color: #888;
                  font-size: 12px;

                }
              }
              .tips {
                position: absolute;
                top: -38px;
                left: 50%;
                -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
                display: none;
                font-size: 12px;
                color: #ffffff;
                line-height: 30px;
                padding: 0 10px;
                background: rgba(0, 0, 0, 0.8);
                border-radius: 2px;
                font-style: normal;
                white-space: nowrap;

                &:after {
                  content: '';
                  position: absolute;
                  left: 50%;
                  bottom: -12px;
                  width: 0;
                  height: 0;
                  border: 6px solid rgba(0, 0, 0, 0.8);
                  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
                  margin-left: -6px;
                }

              }
            }
            .downMask {
              position: absolute;
              top: 0px;
              left: 0px;
              width: 88px;
              height: 88px;
              background: rgba(0, 0, 0, 0.5);
              &:hover {
                .tips {
                  font-family: 'pingFang-SC-Regular', '微软雅黑', Arial;
                  display: inline-block;
                }
              }
              p {
                position: absolute;
                left: 15px;
                top: 32px;
                width: 58px;
                height: 24px;
                background-color: #20a0ff;
                color: white;
                line-height: 24px;
                text-align: center;
                border-radius: 5px;
                &.down {
                  background-color: #fafafa;
                  color: #888;
                  font-size: 12px;

                }
              }
              .tips {
                position: absolute;
                top: -38px;
                left: 50%;
                -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
                display: none;
                font-size: 12px;
                color: #ffffff;
                line-height: 30px;
                padding: 0 10px;
                background: rgba(0, 0, 0, 0.8);
                border-radius: 2px;
                font-style: normal;
                white-space: nowrap;

                &:after {
                  content: '';
                  position: absolute;
                  left: 50%;
                  bottom: -12px;
                  width: 0;
                  height: 0;
                  border: 6px solid rgba(0, 0, 0, 0.8);
                  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
                  margin-left: -6px;
                }

              }
            }
            .checkMask {
              position: absolute;
              top: 0px;
              left: 0px;
              width: 88px;
              height: 88px;
              background: rgba(255, 255, 255, 0.5);
              &:hover {
                .tips {
                  font-family: 'pingFang-SC-Regular', '微软雅黑', Arial;
                  display: inline-block;
                }
              }
              p {
                position: absolute;
                left: 15px;
                top: 32px;
                width: 58px;
                height: 24px;
                background-color: #20a0ff;
                color: white;
                line-height: 24px;
                text-align: center;
                border-radius: 5px;
                &.check {
                  background-color: #20a0ff;
                  color: #ffffff;
                  font-size: 12px;
                }
              }
              .tips {
                position: absolute;
                top: -38px;
                left: 50%;
                -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
                display: none;
                font-size: 12px;
                color: #ffffff;
                line-height: 30px;
                padding: 0 10px;
                background: rgba(0, 0, 0, 0.8);
                border-radius: 2px;
                font-style: normal;
                white-space: nowrap;

                &:after {
                  content: '';
                  position: absolute;
                  left: 50%;
                  bottom: -12px;
                  width: 0;
                  height: 0;
                  border: 6px solid rgba(0, 0, 0, 0.8);
                  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
                  margin-left: -6px;
                }

              }
            }
            >a {
              width: 88px;
              height: 88px;
              display: block;
              float: left;
              >img {
                width: 100%;
                height: 100%;
              }
            }
            a:nth-child(8n+1) {
              margin-left: 0px;
            }
            a+a {
              margin-left: 16px;
            }
          }
        }
        .upload-search-null {
          width: 831px;
          height: 83px;
          margin: 135px 0;
          text-align: center;
          color: #878996;
          font-size: 16px;
          p {
            margin-top: 25px;
          }
          span {
            color: #ff6600;
          }
        }
      }
    }
    .upload-search-null {
      width: 831px;
      height: 83px;
      margin: 135px 0;
      text-align: center;
      color: #878996;
      font-size: 16px;
      p {
        margin-top: 25px;
      }
      span {
        color: #ff6600;
      }
    }


  }
</style>


// WEBPACK FOOTER //
// upload.vue?e179a21e